import React from 'react';
import { Helmet } from 'react-helmet-async';
import './Terms.css';

function Terms() {
  return (
    <div className="terms-section">
      <Helmet>
        <title>Terms & Conditions | Szakacs Visuals Photography Services</title>
        <meta name="description" content="Terms and conditions for Szakacs Visuals photography services. Read our policies regarding bookings, cancellations, and service agreements." />
        <meta name="keywords" content="photography terms and conditions, photography service agreement, Bristol photographer terms, photography booking policy" />
        <meta property="og:title" content="Terms & Conditions | Szakacs Visuals Photography Services" />
        <meta property="og:description" content="Terms and conditions for Szakacs Visuals photography services. Read our policies regarding bookings, cancellations, and service agreements." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://szakacsvisuals.co.uk/terms" />
        <link rel="canonical" href="https://szakacsvisuals.co.uk/terms" />
      </Helmet>
      <div className="terms-container">
        <h1>Terms & Conditions</h1>
        <div className="terms-content">
          <div className="business-info">
            <p>Business Name: Szakacs Visuals</p>
          </div>

          <section>
            <h2>Terms for Individual Clients</h2>
            <p>(Weddings, Christenings, Baby Showers, Newborn Shooting, etc.)</p>
          </section>

          <section>
            <h2>Booking and Deposit</h2>
            <ul>
                <li>Bookings can be made by using the contact page to send a message with your preferred dates and all relevant details.</li>
                <li>After receiving your message, I will arrange a phone call, video call, or face-to-face meeting to discuss and confirm the booking.</li>
                <li>If we both agree to proceed, I will send a contract via email for you to review, sign, and return.</li>
                <li>Once the signed contract is received, I will send an invoice for bank transfer or a payment link for the deposit.</li>
                <li>The deposit of 50% must be paid to secure the booking and is non-refundable under any circumstances.</li>

            </ul>
          </section>

          <section>
            <h2>Payment</h2>
            <ul>
              <li>The remaining 50% balance must be paid no later than one week prior to the event.</li>
            </ul>
          </section>

          <section>
            <h2>Transport Costs</h2>
            <ul>
              <li>Transport costs are additional and will be detailed in the contract.</li>
            </ul>
          </section>

          <section>
            <h2>Delivery of Products</h2>
            <ul>
              <li>All digital products will be delivered within 10 working days via an online gallery.</li>
              <li>A personalized USB stick will also be sent to the address provided by the client.</li>
            </ul>
          </section>

          <section>
            <h2>Editing and Usage</h2>
            <ul>
              <li>As the photographer, I reserve the right to edit the photos and videos according to my creative style. Clients are not permitted to modify or edit the final products.</li>
              <li>If clients upload the photos or videos to social media, they must not apply additional filters or edits.</li>
            </ul>
          </section>

          <section>
            <h2>Terms for Business Clients</h2>
          </section>

          <section>
            <h2>Booking and Deposit</h2>
            <ul>
            <li>Bookings can only be made through the contact page by sending a message with your preferred dates and details.</li>
            <li>A non-refundable deposit is required to secure the booking.</li>
            <li>After receiving your inquiry, I will contact you within 24 hours to discuss details and send a contract for signature.</li>
            <li>Bookings can also be made via phone or email. In such cases, I will provide bank details or a payment link for the deposit, which must be paid promptly.</li>
            <li>The deposit remains non-refundable under all circumstances.</li>
            </ul>
          </section>

          <section>
            <h2>Payment</h2>
            <ul>
              <li>Digital products will be delivered within 10 working days.</li>
              <li>Full payment is due upon receipt of the final invoice.</li>
              <li>Invoices must be paid within 30 days.</li>
            </ul>
          </section>

          <section>
            <h2>Editing and Usage</h2>
            <ul>
              <li>I reserve the rights to all photos and videos.</li>
              <li>I may use the materials for promotional purposes on my website or other social media platforms.</li>
            </ul>
          </section>

          <section>
            <h2>General Terms</h2>
            <ol>
              <li>By booking a service, clients agree to these Terms and Conditions.</li>
              <li>Any changes to these terms must be agreed upon in writing.</li>
              <li>For any queries, clients can contact me directly for clarification.</li>
            </ol>
          </section>

          <div className="contact-info">
            <p>Email: szakacs.visuals@gmail.com</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Terms; 